import {QueryClient, useQuery} from "react-query";
import * as api from "../api/easeedesk/apis";

const searchRelated = async (options) => {
    const {response, error} = await api.fetchTicketRelated(options);

    return response ? response.data.data : response;
};

export default function useTicketRelated(options) {
    return useQuery([
        'ticket_related',
        options
    ], () => searchRelated(options), {refetchOnWindowFocus: false});
}
